<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import FormattedContent from './Text/FormattedContent.vue';
import CardItem from './cards/CardItem.vue';
import Carousel from './cards/Carousel.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();

const cards = computed(() => {
  return Array.isArray(contentAttributes.value?.items)
    ? contentAttributes.value.items
    : [];
});

const normalizedCards = computed(() => {
  return cards.value.map(item => ({
    title: item.title || '',
    description: item.description || item.content || '',
    imageUrl:
      item.mediaUrl || item.media_url || item.imageUrl || item.image_url || '',
    actions: Array.isArray(item.actions) ? item.actions : [],
  }));
});

const bubbleText = computed(() => content.value || '');
const shouldRenderCarousel = computed(() => normalizedCards.value.length > 1);
</script>

<template>
  <BaseBubble class="overflow-hidden px-3 py-3" data-bubble-name="cards">
    <div class="flex flex-col gap-3">
      <FormattedContent v-if="bubbleText" :content="bubbleText" />

      <Carousel
        v-if="shouldRenderCarousel"
        :cards="normalizedCards"
        :bubble-text="bubbleText"
      />

      <CardItem
        v-else-if="normalizedCards[0]"
        :card="normalizedCards[0]"
        :bubble-text="bubbleText"
      />
    </div>
  </BaseBubble>
</template>
